import React from 'react';
import { Instagram } from 'lucide-react';

const InstagramCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 via-white to-orange-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <Instagram className="w-16 h-16 mx-auto text-amber-700 mb-6" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-6 tracking-wide">
          Follow Our Gifting Journey
        </h2>
        <p className="text-lg text-neutral-700 mb-8 max-w-2xl mx-auto leading-relaxed">
          Discover our latest curated collections, behind-the-scenes stories, and gifting inspiration through our Instagram. Each piece is crafted with intention and care, just for you.
        </p>
        <a
          href="https://www.instagram.com/guriva.gifts/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 text-sm tracking-widest uppercase hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          <Instagram size={20} />
          Follow @guriva.gifts
        </a>
        <p className="mt-6 text-sm text-neutral-600">
          Shop directly through Instagram DMs or explore our featured collections
        </p>
      </div>
    </section>
  );
};

export default InstagramCTA;
